import React from "react";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";

const getDialNumber = (mobile) => String(mobile || "").replace(/\D/g, "");

const getWhatsappNumber = (mobile) => {
  const digits = getDialNumber(mobile);

  if (digits.length === 10) return `91${digits}`;

  return digits;
};

export default function MobileContactMenu({ mobile }) {
  const dialNumber = getDialNumber(mobile);
  const whatsappNumber = getWhatsappNumber(mobile);

  if (!dialNumber) {
    return <span>-</span>;
  }

  return (
    <Menu>
      <MenuButton
        as="button"
        type="button"
        className="font-semibold text-bgBlue hover:underline"
      >
        {mobile}
      </MenuButton>
      <MenuList minW="160px">
        <MenuItem
          icon={<FaWhatsapp />}
          as="a"
          href={`https://wa.me/${whatsappNumber}`}
          target="_blank"
          rel="noreferrer"
        >
          WhatsApp Call
        </MenuItem>
        <MenuItem icon={<FaPhoneAlt />} as="a" href={`tel:${dialNumber}`}>
          Normal Call
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
